// Local Environment
export const environment = 'local';
export const apiRootUrl = 'https://saas-api-dev.vetting.com';
export const coreApiRootUrl = 'https://api-dev.vetting.com';
// export const coreApiRootUrl = 'https://localhost:7006';
// Necessary as this value is replaced by webpack
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const country: string = 'Australia'; // From the Region value of GetCurrencies microservice
export const countryIsUk = country !== 'Australia';
export const reactAppinsightsInstrumentationKey = 'e66249bb-6fcf-4c18-af31-5d97e3b0f25c';
export const sentryDsn: string = null;
export const recaptchaSiteKey = '6LeuBpAUAAAAAN7Ikn5ijOz1TwBwBb2eL6fwDvQK';
export const stripePublicKey =
	'pk_test_51BTUDGJAJfZb9HEBwDg86TN1KNprHjkfipXmEDMb0gSCassK5T3ZfxsAbcgKVmAIXF7oZ6ItlZZbXO6idTHE67IM007EwQ4uN3';
export const uninterruptedYearsOfAddressHistories = 5;
export const AcicEnvironment = 'TRAIN';
export const Version: string = null;
export const bullhornRestApiUrl = 'https://rest.bullhornstaffing.com';
export const bullhornAuthUrl = 'https://auth.bullhornstaffing.com';
export const jobAdderRestApiUrl = 'https://sandboxapi.jobadder.com/v2/';
export const jobAdderAuthUrl = 'https://id.jobadder.com';
export const smartRecruitersUrl = 'https://api.smartrecruiters.com';
export const connectIDParticipantsUrl = 'https://data.directory.sandbox.connectid.com.au/participants';
